// Fix pre Marfeel SDK URL chyby v development prostredí
export function initMarfeelUrlFix() {
  // Uložíme originálny URL constructor
  const OriginalURL = window.URL;

  // Vytvoríme wrapper pre URL constructor
  window.URL = new Proxy(OriginalURL, {
    construct(target, args) {
      const [url, base] = args;

      try {
        // Pokúsime sa vytvoriť URL normálne
        return new target(url, base);
      } catch (error) {
        // Ak zlyhá a je to Marfeel SDK, použijeme mock URL
        const stack = new Error().stack || '';
        if (stack.includes('marfeel-sdk')) {
          console.warn('Marfeel SDK attempted to create invalid URL:', url, 'Using fallback.');
          // Vrátime mock URL objekt s aktuálnou doménou
          return new target(window.location.origin);
        }
        // Pre ostatné prípady vyhodíme pôvodnú chybu
        throw error;
      }
    }
  });
}